import { globalConstants } from "../constants";
import {
  putRequest,
  getRequest,
  postRequest,
  deleteRequest,
  getRequestWithParams,
  postRequestWithFiles,
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";
async function getUsers(GetData) {
  return getRequestWithParams(
    `/${globalConstants.VERSION}/admin/User/approved`,
    true,
    GetData
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function getApprovals(GetData) {
  return getRequestWithParams(
    `/${globalConstants.VERSION}/admin/User/pending`,
    true,
    GetData
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function certifiedPractioner(certifiedPractitionerDocs, userID) {
  return postRequestWithFiles(
    `/${globalConstants.VERSION}/Documents/practioner/${userID}`,
    certifiedPractitionerDocs,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function getUserById(userID) {
  return getRequest(
    `/${globalConstants.VERSION}/admin/User/approved/${userID}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getApprovalUserById(userID) {
  return getRequestWithParams(
    `/${globalConstants.VERSION}/admin/User/pending/${userID}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getUserSportsById(userID) {
  return getRequestWithParams(
    `/${globalConstants.VERSION}/user/sports/${userID}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function updateUser(userUpdatedData) {
  return putRequest(
    `/${globalConstants.VERSION}/admin/User`,
    userUpdatedData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function approvedCertificate(documentStatuses) {
  return postRequest(
    `/${globalConstants.VERSION}/admin/Practitioner/approval`,
    documentStatuses,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function approvedDocuments(documentStatuses) {
  return postRequest(
    `/${globalConstants.VERSION}/admin/User/approval`,
    documentStatuses
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function RejectDocuments() {
  return true;
  // return await axios.post(`${API_ENDPOINT}/${globalConstants.VERSION}/URLREQUIRED/${approvedData}`);
}

async function becomeInstructor(certificates, userID) {
  return postRequestWithFiles(
    `/${globalConstants.VERSION}/Documents/instructor/${userID}`,
    certificates,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getAdminUserById(userID) {
  return getRequest(`/${globalConstants.VERSION}/admin/get/${userID}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function getAdminUsers(GetData) {
  return postRequest(
    `/${globalConstants.VERSION}/Admin/get`,
    GetData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function createAdminUser(data) {
  return postRequest(
    `/${globalConstants.VERSION}/Admin
`,
    data
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function updateAdminUser(userUpdatedData) {
  return putRequest(
    `/${globalConstants.VERSION}/admin/User`,
    userUpdatedData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function updateAdminUserStatus(data) {
  return putRequest(
    `/${globalConstants.VERSION}/admin/updateStatus`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function deleteAdminUser(userId) {
  return deleteRequest(
    `/${globalConstants.VERSION}/admin/delete/${userId}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

const exportUserData = (gridState, requestType) => {
  return postRequest(
    `/${globalConstants.VERSION}/admin/User/export/users/${requestType}`,
    gridState
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getDashoboardData = (systemUserId, pageSize) => {
  return getRequestWithParams(
    `/${globalConstants.VERSION}/user/dashboard/${systemUserId}/${pageSize}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getUserRecommendationsData = (systemUserId, params) => {
  return postRequest(
    `/${globalConstants.VERSION}/User/recommendations/${systemUserId}`,
    params,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const becomeMember = (checkout) => {
  return postRequest(
    `/${globalConstants.VERSION}/User/member`,
    checkout,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const cancelMembership = (systemUserId) => {
  return putRequest(
    `/${globalConstants.VERSION}/User/cancel/${systemUserId}`,
    {},
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const becomeMemberWithSavedCard = (data) => {
  return postRequest(
    `/${globalConstants.VERSION}/User/savedCard/member`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const userService = {
  getUsers,
  certifiedPractioner,
  getApprovals,
  getUserById,
  updateUser,
  approvedCertificate,
  approvedDocuments,
  RejectDocuments,
  getApprovalUserById,
  becomeInstructor,
  deleteAdminUser,
  updateAdminUser,
  createAdminUser,
  getAdminUsers,
  getAdminUserById,
  updateAdminUserStatus,
  exportUserData,
  getDashoboardData,
  getUserRecommendationsData,
  getUserSportsById,
  becomeMember,
  cancelMembership,
  becomeMemberWithSavedCard,
};
